<section>
  <div
    class="subtitle-uncollapsed list-item-subtitle"
    [ngClass]="{ 'subtitle-visible': isVisible, 'subtitle-hidden': !isVisible }"
    (click)="toggleVisible()"
    >
    <ng-content select="va-filter-section-title"></ng-content>
    @if (!isVisible) {
      <i class="material-icons arrow">keyboard_arrow_right</i>
    }
    @if (isVisible) {
      <i class="material-icons arrow">keyboard_arrow_down</i>
    }
  </div>
  @if (isVisible) {
    <div class="list-item-uncollapsed">
      <ng-content></ng-content>
    </div>
  }
</section>
